import {
  Chip,
  GlobalCard,
  GlobalCardBody,
  GlobalCardHeader,
  GlobalCardHeaderTitle,
} from '@global-engineering-shared/gweb-material-global';
import { Button, Typography } from '@global-engineering-shared/gweb-material-ui';
import React, { useEffect, useState } from 'react';

import { useFilters } from 'context/FilterProvider/FilterProvider';
import useStyles from 'features/Filters/FilterChipsContainer/FilterChipsContainer.styles';
import { Filters } from 'features/Filters/types/Filters';
import { defaultFilters } from 'features/Filters/utils/defaultFilters';

type FilterChipProps = {
  name: string;
  filterType: string;
};

const FilterChipsContainer = () => {
  const classes = useStyles();
  const [filterChips, setFilterChips] = useState<FilterChipProps[]>([]);

  const { filters, setFilters } = useFilters();

  useEffect(() => {
    const filterChipsBuilder: FilterChipProps[] = [];

    Object.keys(filters).forEach((filterType) => {
      const currentFilters = filters[filterType as keyof Filters];

      if (filterType === 'spaceIds') {
        if (currentFilters.length > 0) {
          filterChipsBuilder.push({ name: currentFilters[0], filterType: filterType });
        }
      } else {
        currentFilters.forEach((f) => {
          filterChipsBuilder.push({ name: f, filterType: filterType });
        });
      }
    });

    setFilterChips(filterChipsBuilder);
  }, [filters]);

  const removeSingleFilter = (filterValue: string, filterType: string) => () => {
    const updatedFilters = filters;

    if (filterType === 'spaceIds') {
      updatedFilters[filterType as keyof Filters] = [];
    }
    const filterTypeToUpdate = updatedFilters[filterType as keyof Filters];

    filterTypeToUpdate.splice(filterTypeToUpdate.indexOf(filterValue), 1);

    setFilters(updatedFilters);
  };

  const getLabel = (filter: FilterChipProps) => {
    if (filter.filterType === 'spaceIds') {
      return `${filters.spaceIds?.length} Space IDs`;
    }
    return filter.name;
  };

  return (
    <GlobalCard className={classes.filterCard}>
      <GlobalCardHeader>
        <GlobalCardHeaderTitle
          TitleComponent={() => <Typography className={classes.labelTitle}>FILTERS</Typography>}
        />
      </GlobalCardHeader>
      <GlobalCardBody>
        {filterChips.map((filter) => (
          <Chip
            className={classes.filterChip}
            label={getLabel(filter)}
            key={filter.name}
            onDelete={removeSingleFilter(filter.name, filter.filterType)}
          />
        ))}
        <Button variant="text" onClick={() => setFilters(defaultFilters)}>
          <span className={classes.clearFilters}>Clear All</span>
        </Button>
      </GlobalCardBody>
    </GlobalCard>
  );
};

export default FilterChipsContainer;
